<template>
  <div>
    <div class="contact-banner">
      <div class="left-side">
        <div class="avatars">
          <div v-for="link in notchMemberPictureLinks" :key="link" class="avatar">
            <img class="image-size" :src="link" />
          </div>
        </div>
      </div>
      <div class="right-side">
        <n-button :label="$t('general.close')" variant="tertiary" @click="onClose" />
        <n-button
          icon="play"
          :label="$t('framework.watchDemoVideo')"
          variant="secondary"
          @click="showGettingStartedModal = true"
        />
        <n-button :label="$t('framework.bookDemo')" @click="showTalkToSalesModal = true" />
      </div>
    </div>
    <GettingStartedModal
      v-if="showGettingStartedModal"
      @dismiss="showGettingStartedModal = false"
      @close="showGettingStartedModal = false"
    />
    <TalkToSalesModal v-if="showTalkToSalesModal" @close="showTalkToSalesModal = false" />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import GettingStartedModal from '@/modules/global/components/GettingStartedModal.vue'
import TalkToSalesModal from '@/modules/global/components/TalkToSalesModal.vue'
import { mapStores } from 'pinia'
import { useSnackbarStore, SnackbarStore } from '@/modules/global/stores/SnackbarStore'

@Component({
  components: { TalkToSalesModal, GettingStartedModal },
  computed: mapStores(useSnackbarStore)
})
export default class ContactBanner extends Vue {
  @Prop() snackbarId!: string

  private showGettingStartedModal = false
  private showTalkToSalesModal = false

  private bookDemoLink: string = 'https://calendly.com/callnotch/notch-discovery'

  private snackbarStore!: SnackbarStore

  private notchMemberPictureLinks = [
    `${import.meta.env.VITE_NOTCH_STATIC_STORAGE}/contact-banner-thomas.png`,
    `${import.meta.env.VITE_NOTCH_STATIC_STORAGE}/contact-banner-tim.png`,
    `${import.meta.env.VITE_NOTCH_STATIC_STORAGE}/contact-banner-vitkor.png`
  ]

  onClose() {
    if (this.snackbarId) {
      this.snackbarStore.dequeue(this.snackbarId)
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.contact-banner {
  width: clamp($notch-space-130x, 50vw, $notch-space-190x);
  display: flex;
  justify-content: space-between;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  padding: $notch-space-2x;
  border-radius: $notch-radius-full;
  border: 2px solid $notch-color-neutral-sand-200;
  background-color: $notch-color-neutral-grey-000;

  @include mobile {
    right: $notch-space-4x;
    bottom: $notch-space-4x;
  }

  .right-side {
    display: flex;
    gap: $notch-space-2x;
  }

  .avatars {
    display: flex;
    align-items: center;
    height: 100%;
    margin-left: $notch-space-2x;

    .avatar {
      display: flex;
      border-radius: $notch-radius-full;
      overflow: hidden;
      border: 2px solid $notch-color-neutral-grey-000;
      margin-left: -$notch-space-2x;

      .image-size {
        width: $notch-space-8x;
        height: $notch-space-8x;
      }
    }
  }
}
</style>
